"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.registerEventHandler = void 0;
var registerEventHandler = function registerEventHandler(eventType, runCallbacks) {
  var handlerObj = {
    running: false,
    unsetRunning: function unsetRunning() {
      return handlerObj.running = false;
    },
    unsubscribe: function unsubscribe() {
      return window.removeEventListener(eventType, runHandler);
    }
  };
  var runHandler = function runHandler() {
    if (window.requestAnimationFrame) {
      window.requestAnimationFrame(runCallbacks);
    } else {
      setTimeout(runCallbacks, 200);
    }
  };
  window.addEventListener(eventType, runHandler);
  return handlerObj;
};
exports.registerEventHandler = registerEventHandler;